import React, { useRef, useState, useEffect, useMemo } from 'react';
import { useSnackbar } from 'notistack';
// @mui
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import { Box, Paper, Typography } from '@mui/material';
// utils
import { fData } from '../../utils/formatNumber';

// ----------------------------------------------------------------------

RejectionFileThemes.propTypes = {
    fileRejections: PropTypes.array,
};

export default function RejectionFileThemes({ fileRejections }) {
    const { enqueueSnackbar } = useSnackbar();
    const [ErrorValue, setErrorValue] = useState('');

    // useEffect(()=>{
    //     if(ErrorValue && ErrorValue!==''){
    //         enqueueSnackbar(ErrorValue , {variant:'error'});
    //     }
    // },[ErrorValue])

    useEffect(() => {
        if (fileRejections && fileRejections.length > 0) {
            if (fileRejections[0].errors && fileRejections[0].errors.length > 0) {
                if (fileRejections[0].errors[0].code === "file-too-large") {
                    enqueueSnackbar('File should be less than 20 MB', { variant: 'error' });
                } else {
                    enqueueSnackbar(fileRejections[0].errors[0].message, { variant: 'error' });
                }
            }
        }
    }, [fileRejections]);

    return (
        <Paper
            variant="outlined"
            sx={{
                py: 1,
                px: 2,
                mt: 3,
                borderColor: 'error.light',

            }}
        >
            {fileRejections.map(({ file, errors }) => {
                const { path, size } = file;

                return (
                    <Box key={path} sx={{ my: 1 }}>
                        {/* <Typography variant="subtitle2" noWrap>
                            {path} - {fData(size)}
                        </Typography> */}
                        {/* {errors.map((error) => (
                            <Typography key={error.code} variant="caption" component="p" >
                                 - {error.code === 'file-too-large' ? 'File should be less than 20 MB.':error.message}  
                            </Typography>
                        ))} */}
                    </Box>
                );
            })}
        </Paper>
    );
}
